import { render, staticRenderFns } from "./SiteAdminNotificationSettings.vue?vue&type=template&id=53e4b4fe"
import script from "./SiteAdminNotificationSettings.vue?vue&type=script&lang=js"
export * from "./SiteAdminNotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports